import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import SectionHeader from '../components/common/SectionHeader';
import Tabs from '../components/common/Tabs';
import VideoCard from '../components/common/VideoCard';

const videos = [
  { title: 'Spot "Abitare Giovane" — Il diritto di restare', duration: '5:22', category: 'Campagna', date: '10 Mar', image: 'https://images.unsplash.com/photo-1492724441997-5dc865305da7?q=80&w=800&auto=format&fit=crop' },
  { title: 'Intervista a Giulia Marchetti: il futuro dei GD', duration: '28:10', category: 'Intervista', date: '5 Mar', image: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=800&auto=format&fit=crop' },
  { title: 'Scuola Quadri: lezione su comunicazione politica', duration: '45:20', category: 'Formazione', date: '28 Feb', image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=800&auto=format&fit=crop' },
  { title: 'Spot "Scuola Libera" — Educazione per tutti', duration: '3:15', category: 'Campagna', date: '20 Feb', image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?q=80&w=800&auto=format&fit=crop' },
  { title: 'Reportage dal Congresso Regionale Toscana', duration: '18:44', category: 'Reportage', date: '15 Feb', image: 'https://images.unsplash.com/photo-1505373630103-821c70e3c8ad?q=80&w=800&auto=format&fit=crop' },
  { title: 'Dibattito: lavoro precario e salario minimo', duration: '22:30', category: 'Dibattito', date: '10 Feb', image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=800&auto=format&fit=crop' },
];

const VideoPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Video' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Media" title="Video" subtitle="Assemblee, interventi, spot, interviste e reportage della nostra attività in video." />
      <section className="section section--sm"><div className="container">
        <Tabs items={['Tutti', 'Assemblee', 'Interviste', 'Campagne', 'Formazione']} className="mb-8" />
        <VideoCard variant="hero" title="L'intervento del Segretario Nazionale all'Assemblea" duration="12:34" link="/video-dettaglio" image="https://images.unsplash.com/photo-1492724441997-5dc865305da7?q=80&w=1600&auto=format&fit=crop" />
        <SectionHeader className="mb-6 mt-10" />
        <div className="grid grid-3">{videos.map((v) => <VideoCard key={v.title} {...v} link="/video-dettaglio" />)}</div>
      </div></section>
    </Layout>
  );
};

export default VideoPage;
